module.exports = __webpack_public_path__ + "img/icon-data-light.d7b9c0db.svg";